import { render } from "./NewFactory.vue?vue&type=template&id=2fce4f89"
import script from "./NewFactory.vue?vue&type=script&lang=js"
export * from "./NewFactory.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__